// Add role="search" to SIDR and other search forms
wpex.domReady(async function() {
    let formSelectors = [ '#sidr-main form', 'form.searchform'];

    // Loop through selectors
    SL9.a11y.setAriaAttr(formSelectors, 'search');
    
});